"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 29. 10. 2020
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converter for {@link ProductCategoryChange product category tree change}.
 *
 * @author Radek Beran
 */


var ProductCategoryChangeConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductCategoryChangeConverter, _DataObjectConverter_);

  function ProductCategoryChangeConverter() {
    _classCallCheck(this, ProductCategoryChangeConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductCategoryChangeConverter).apply(this, arguments));
  }

  return ProductCategoryChangeConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductCategoryChangeConverter = ProductCategoryChangeConverter;